import CartGarment from './Garment';

export default CartGarment;
